module.exports = __webpack_public_path__ + "static/media/29ADMSPC29.c927d181.jpg";